import { render } from "./RatioVacsChart.vue?vue&type=template&id=007bb56e&scoped=true"
import script from "./RatioVacsChart.vue?vue&type=script&lang=js"
export * from "./RatioVacsChart.vue?vue&type=script&lang=js"

import "./RatioVacsChart.vue?vue&type=style&index=0&id=007bb56e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007bb56e"]])

export default __exports__